module.exports = __webpack_public_path__ + "static/media/userpic.c3a10dc1.png";